var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MeetingType } from '@web/components/Filters/Elements/MeetingType';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { ChartSeriesVisibility } from '@web/components/layout/RechartsItems/ChartSeriesVisibility';
import CustomTooltip from '@web/components/layout/RechartsItems/CustomTooltip';
import { createEdgePositionedBarTooltipContent } from '@web/components/layout/RechartsItems/EdgePositionedBarTooltip';
import LegendItem from '@web/components/layout/RechartsItems/LegendItem';
import { PeriodBarChart } from '@web/components/layout/RechartsItems/PeriodBarChart';
import { rechartsDiagonalStripeFillUrl } from '@web/components/layout/RechartsItems/rechartsDiagonalStripes';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { SCHEDULED_MEET_ATTENDANCE_RATE_COLORS_CONFIG, TablesDiffColorsConfig } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled } from '@web/utility';
import { createPeriodComparisonSeriesLabelFormatter } from '@web/utility/ tooltip/periodComparisonTooltip';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { ComparisonPeriod, navigateFromPeriodChartBarClick } from '@web/utility/searchMeetingsNavigation';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { getInterval } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
var SCHEDULED_MEET_ATTENDANCE_SERIES_KEYS = ['attended', 'skipped'];
var TABLES_DATA_PREFIX = 'app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData';
var colorsConfig = SCHEDULED_MEET_ATTENDANCE_RATE_COLORS_CONFIG;
var teamStripePatternId = function (dataKey) { return "".concat(InsightTypeEnum.scheduledMeetAttendanceRate, "_").concat(dataKey); };
var mapScheduledMeetAttendanceChartData = function (periods, teamPeriods, showTeamBars) {
    return periods.map(function (period, index) {
        var teamPeriod = teamPeriods === null || teamPeriods === void 0 ? void 0 : teamPeriods[index];
        return __assign({ period: period.period, previousPeriodLabel: period.previousPeriodLabel, previousAttended: period.prevAttended, previousSkipped: period.prevSkipped, currentAttended: period.attended, currentSkipped: period.skipped }, (showTeamBars && teamPeriod
            ? {
                teamAverageAttended: teamPeriod.teamAverageAttended,
                teamAverageSkipped: teamPeriod.teamAverageSkipped
            }
            : {}));
    });
};
export var ScheduledMeetAttendanceRate = function (_a) {
    var _b;
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var _c = trpc.scheduledMeetAttendanceRate.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }), data = _c.data, isLoading = _c.isLoading, refetch = _c.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var showTeamBars = Boolean(userId && ((_b = data.teamPeriods) === null || _b === void 0 ? void 0 : _b.length));
    var chartData = mapScheduledMeetAttendanceChartData(data.periods, data.teamPeriods, showTeamBars);
    var interval = getInterval(dateFrom, dateTo);
    var attendedLabel = t("".concat(TABLES_DATA_PREFIX, ".attendedMeetings"));
    var skippedLabel = t("".concat(TABLES_DATA_PREFIX, ".skippedMeetings"));
    var teamAverageLabel = t('export.teamAverage');
    var handleBarClick = function (barData, fallbackIndex, stack) {
        navigateFromPeriodChartBarClick({
            navigateTo: navigateTo,
            chartData: chartData,
            barData: barData,
            fallbackIndex: fallbackIndex,
            dateFrom: dateFrom,
            dateTo: dateTo,
            userId: userId,
            orgUnitId: orgUnitId,
            meetingType: MeetingType.SCHEDULED,
            stack: stack
        });
    };
    return (_jsxs("div", { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.scheduledMeetingAttendanceRate'), description: t('widgetTitleDescriptions.scheduleAndAttendance.scheduledMeetAttendanceRate'), insightType: InsightTypeEnum.scheduledMeetAttendanceRate, insightsData: data, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.scheduledMeetingAttendanceRate'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            return [2 /*return*/, ((_a = data.periods) !== null && _a !== void 0 ? _a : []).map(function (period, index) {
                                    var _a, _b;
                                    var _c;
                                    var teamPeriod = (_c = data.teamPeriods) === null || _c === void 0 ? void 0 : _c[index];
                                    var teamRow = userId && teamPeriod
                                        ? (_a = {},
                                            _a["".concat(teamAverageLabel, " ").concat(attendedLabel)] = teamPeriod.teamAverageAttended,
                                            _a["".concat(teamAverageLabel, " ").concat(skippedLabel)] = teamPeriod.teamAverageSkipped,
                                            _a) : {};
                                    return __assign((_b = {}, _b[t('filters.period')] = period.period, _b[attendedLabel] = period.attended, _b[skippedLabel] = period.skipped, _b), teamRow);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(data) }) }), _jsx(ChartSeriesVisibility, __assign({ seriesKeys: SCHEDULED_MEET_ATTENDANCE_SERIES_KEYS }, { children: function (_a) {
                    var toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible;
                    return (_jsx(PeriodBarChart, { chartData: chartData, dateFrom: dateFrom, dateTo: dateTo, interval: interval, barsPerGroup: showTeamBars ? 3 : 2, allowDecimals: false, tooltipContent: createEdgePositionedBarTooltipContent(_jsx(CustomTooltip, { seriesOrder: showTeamBars
                                ? [
                                    'previousAttended',
                                    'previousSkipped',
                                    'currentAttended',
                                    'currentSkipped',
                                    'teamAverageAttended',
                                    'teamAverageSkipped'
                                ]
                                : [
                                    'previousAttended',
                                    'previousSkipped',
                                    'currentAttended',
                                    'currentSkipped'
                                ], periodComparisonTooltip: true, seriesLabelFormatter: createPeriodComparisonSeriesLabelFormatter({
                                attended: attendedLabel,
                                skipped: skippedLabel,
                                teamAverageAttended: "".concat(teamAverageLabel, " ").concat(attendedLabel),
                                teamAverageSkipped: "".concat(teamAverageLabel, " ").concat(skippedLabel)
                            }), separatorAfterDataKeys: showTeamBars ? ['currentSkipped'] : undefined, stripeSwatchColors: showTeamBars
                                ? {
                                    teamAverageAttended: colorsConfig.attended.teamAvgChartColor,
                                    teamAverageSkipped: colorsConfig.skipped.teamAvgChartColor
                                }
                                : undefined }), chartData.length), legend: SCHEDULED_MEET_ATTENDANCE_SERIES_KEYS.map(function (key) {
                            var _a;
                            return (_jsx(LegendItem, { color: colorsConfig[key].color, label: t("".concat(TABLES_DATA_PREFIX, ".").concat(colorsConfig[key].translationKey)), currentValue: "".concat(data.totals[key].current, " / ").concat(data.totals[key].currentDuration), diffValue: data.totals[key].previous, teamAverage: userId
                                    ? ((_a = data.totals[key].teamAverage) !== null && _a !== void 0 ? _a : undefined)
                                    : undefined, arrowColor: TablesDiffColorsConfig.GREEN, stripeChartColor: showTeamBars ? colorsConfig[key].teamAvgChartColor : undefined, onClick: function () { return toggleSeries(key); }, isHidden: !isSeriesVisible(key) }, key));
                        }), stripePatterns: showTeamBars
                            ? [
                                {
                                    patternId: teamStripePatternId('teamAverageAttended'),
                                    chartColor: colorsConfig.attended.teamAvgChartColor
                                },
                                {
                                    patternId: teamStripePatternId('teamAverageSkipped'),
                                    chartColor: colorsConfig.skipped.teamAvgChartColor
                                }
                            ]
                            : undefined, stacks: __spreadArray([
                            {
                                stackId: 'prev',
                                segments: [
                                    {
                                        dataKey: 'previousAttended',
                                        fill: colorsConfig.attended.prevChartColor,
                                        hide: !isSeriesVisible('attended'),
                                        keyPrefix: 'prev-attended',
                                        onClick: function (barData, index) {
                                            return handleBarClick(barData, index, ComparisonPeriod.Previous);
                                        }
                                    },
                                    {
                                        dataKey: 'previousSkipped',
                                        fill: colorsConfig.skipped.prevChartColor,
                                        hide: !isSeriesVisible('skipped'),
                                        keyPrefix: 'prev-skipped',
                                        onClick: function (barData, index) {
                                            return handleBarClick(barData, index, ComparisonPeriod.Previous);
                                        }
                                    }
                                ]
                            },
                            {
                                stackId: 'curr',
                                segments: [
                                    {
                                        dataKey: 'currentAttended',
                                        fill: colorsConfig.attended.chartColor,
                                        hide: !isSeriesVisible('attended'),
                                        keyPrefix: 'curr-attended',
                                        onClick: function (barData, index) {
                                            return handleBarClick(barData, index, ComparisonPeriod.Current);
                                        }
                                    },
                                    {
                                        dataKey: 'currentSkipped',
                                        fill: colorsConfig.skipped.chartColor,
                                        hide: !isSeriesVisible('skipped'),
                                        keyPrefix: 'curr-skipped',
                                        onClick: function (barData, index) {
                                            return handleBarClick(barData, index, ComparisonPeriod.Current);
                                        }
                                    }
                                ]
                            }
                        ], (showTeamBars
                            ? [
                                {
                                    stackId: 'team',
                                    segments: [
                                        {
                                            dataKey: 'teamAverageAttended',
                                            fill: rechartsDiagonalStripeFillUrl(teamStripePatternId('teamAverageAttended')),
                                            hide: !isSeriesVisible('attended'),
                                            keyPrefix: 'team-attended',
                                            onClick: function (barData, index) {
                                                return handleBarClick(barData, index, ComparisonPeriod.Current);
                                            }
                                        },
                                        {
                                            dataKey: 'teamAverageSkipped',
                                            fill: rechartsDiagonalStripeFillUrl(teamStripePatternId('teamAverageSkipped')),
                                            hide: !isSeriesVisible('skipped'),
                                            keyPrefix: 'team-skipped',
                                            onClick: function (barData, index) {
                                                return handleBarClick(barData, index, ComparisonPeriod.Current);
                                            }
                                        }
                                    ]
                                }
                            ]
                            : []), true) }));
                } }))] }));
};
